// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PropertyList_wrapper__k2RsE"};